import { createReducer, on } from '@ngrx/store';
import {
  CLIENT_FIND_SUCCESS,
  CLIENT_FAILED,
  CLIENT_UPDATE_LOADING,
  CLIENT_UPDATE_FORM,
  CLIENT_ADDRESS_UPDATE_ID,
  CLIENT_FIND_LOCATION_SUCCESS,
  CLIENT_UPDATE_APARTMENT,
  CLIENT_UPDATE_DELIVERY_INSTRUCTIONS,
  CLIENT_PERSONAL_INFORMATION_UPDATE_FORM,
  CLIENT_CLEAR_STATE
 } from '../actions'
import { Address, Client, ClientLocation, User, ClientPersonalInformationForm } from '@core/models';

export interface ClientState {
  loading: boolean;
  client: Client | null;
  user: User | null;
  clientAddressForm: Address | null;
  error: string | null;
  idAddress: string | null;
  location: ClientLocation | null;
  apartmentOrSuite?: string | null;
  deliveryInstructions?: string | null;
  personalInformationForm: ClientPersonalInformationForm | null;
}

const initialState: ClientState = {
  loading: false,
  client: null,
  user: null,
  error: null,
  clientAddressForm: null,
  idAddress: null,
  location: null,
  personalInformationForm: null,
}

export const clientReducer = createReducer(
  initialState,
  on(CLIENT_FIND_SUCCESS, (state, { client }) => ({ ...state, client })),
  on(CLIENT_FAILED, (state, { error }) => ({ ...state, error })),
  on(CLIENT_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(CLIENT_UPDATE_FORM, (state, { clientAddressForm }) => ({ ...state, clientAddressForm })),
  on(CLIENT_ADDRESS_UPDATE_ID, (state, { idAddress }) => ({ ...state, idAddress })),
  on(CLIENT_FIND_LOCATION_SUCCESS, (state, { location }) => ({ ...state, location })),
  on(CLIENT_UPDATE_APARTMENT, (state, { apartmentOrSuite }) => ({...state,apartmentOrSuite})),
  on(CLIENT_PERSONAL_INFORMATION_UPDATE_FORM, (state, { personalInformationForm }) => {
    return {
      ...state,
      personalInformationForm: {
        ...state.personalInformationForm,
        ...personalInformationForm,
      },
    }
  }),
  on(CLIENT_UPDATE_DELIVERY_INSTRUCTIONS, (state, { deliveryInstructions }) => ({...state, deliveryInstructions})),
  on(CLIENT_CLEAR_STATE, () => initialState),
);
